import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { Form } from "react-router-dom";
import { IPurchaseOrder, IPurchaseOrderItem } from "../../../../types/purchaseOrder.types";
import { Modal } from "flowbite-react";
import ProductEdit from "./ProductEdit";

type Props = {
  itens: IPurchaseOrderItem[]
}

export default function EditFormItens(props: Props) {

  const { setFieldValue } = useFormikContext<IPurchaseOrder>();
  const [qtdComponentsPieces, setQtdComponentsPieces] = useState(props.itens.length);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [, setRemoveIndex] = useState<number | null>(null);

  const addComponentProduct = () => {
    setQtdComponentsPieces(qtdComponentsPieces + 1);
    setFieldValue('qtdPieces', qtdComponentsPieces + 1);
  }

  // Confirma remoção
  const confirmRemoveComponentProduct = () => {
    setQtdComponentsPieces(qtdComponentsPieces - 1);
    setFieldValue('qtdPieces', qtdComponentsPieces - 1);
    setShowConfirmModal(false);
    setRemoveIndex(null);
  };

  useEffect(() => {
    const setFormikItens = () => {
      props.itens.map((item, index) => {
        setFieldValue(`item${index}`, { label: item.description, value: item.value });
        setFieldValue(`qtd${index}`, item.qtd);
        setFieldValue(`value${index}`, item.value);
      })
    }
    setFormikItens();
  }, [props.itens, setFieldValue]);

  return (
    <Form>
      <div className="mt-3"></div>
      <div className="overflow-x-auto h-[16rem]">
        <table className="w-full min-w-[800px] border border-gray-300 rounded-lg shadow-sm bg-white">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-2 border-b text-left">Tipo</th>
              <th className="px-4 py-2 border-b text-left">Descrição da Compra</th>
              <th className="px-4 py-2 border-b text-left">Quantidade</th>
              <th className="px-4 py-2 border-b text-left">Valor</th>
              <th className="px-4 py-2 border-b text-left">Ações</th>
            </tr>
          </thead>
          <tbody>
            {new Array(qtdComponentsPieces).fill(null).map((_, i) => <ProductEdit qtdComponentsPieces={qtdComponentsPieces} setRemoveIndex={setRemoveIndex} setShowConfirmModal={setShowConfirmModal} labelIsCounted={`labelIsCounted${i}`} labelIsNotCounted={`labelIsNotCounted${i}`} index={i}></ProductEdit>)}
          </tbody>
        </table>
      </div>
      <div className='flex justify-center'>
        <button
          type="button"
          aria-label="Adicionar novo campo"
          className="mt-4 pb-12 items-center h-12 rounded-md text-black bg-gray-200 px-6 py-2 hover:bg-gray-300 transition"
          onClick={addComponentProduct}
        >
          + Adicionar Campo
        </button>
      </div>

      {/* Modal de confirmação de remoção */}
      <Modal
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        size="md"
      >
        <Modal.Header>
          Confirmar remoção
        </Modal.Header>
        <Modal.Body>
          <p>Tem certeza que deseja remover este item?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="bg-red-600 text-white px-4 py-2 rounded mr-2"
            onClick={confirmRemoveComponentProduct}
          >
            Sim, remover
          </button>
          <button
            className="bg-gray-200 px-4 py-2 rounded"
            onClick={() => setShowConfirmModal(false)}
          >
            Cancelar
          </button>
        </Modal.Footer>
      </Modal>
    </Form>
  )
}